module.exports = __webpack_public_path__ + "img/orders.bff48aa4.svg";